import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AddedEntity } from '../../../shared/models/api-results/base.api-result';
import { prepareQueryParams } from '../../../shared/utils/api-transformations';
import {
  ListNotificationCampaignsResult,
  NotificationCampaignResult,
  NotificationCampaignStatisticsResult,
} from '../../../shared/models/api-results/notification-campaign.api-result';
import {
  WNotificationCampaignsQueryData,
  NotificationCampaignPayload,
  UpdateNotificationCampaignPublishAtPayload,
} from '../../../shared/models/payloads/notification-campaign.payload';
import { NotificationCampaignStatistics } from '../../../shared/models/entities/notification-campaign.entity';

@Injectable({
  providedIn: 'root',
})
export class HttpNotificationCampaignService {
  constructor(private http: HttpClient) {}

  wGet(id: string) {
    return this.http
      .get(`${environment.api_base_url}/notification_campaigns/${id}/notification_campaign_details`)
      .pipe(map((res) => res as NotificationCampaignResult));
  }

  wGetStatistics(id: string) {
    return this.http
      .get(
        `${environment.api_base_url}/notification_campaigns/${id}/notification_campaign_statistics`
      )
      .pipe(map((res) => res as NotificationCampaignStatisticsResult));
  }

  wList(params: WNotificationCampaignsQueryData) {
    return this.http
      .get(`${environment.api_base_url}/notification_campaigns/list_notification_campaigns`, {
        params: prepareQueryParams(params),
      })
      .pipe(map((res) => res as ListNotificationCampaignsResult));
  }

  wAdd(payload: NotificationCampaignPayload) {
    return this.http
      .post(`${environment.api_base_url}/notification_campaigns/add_notification_campaign`, payload)
      .pipe(map((res) => res as AddedEntity));
  }

  wDelete(id: string) {
    return this.http.post(
      `${environment.api_base_url}/notification_campaigns/${id}/delete_notification_campaign`,
      {}
    );
  }

  wUpdatePublishAt(id: string, payload: UpdateNotificationCampaignPublishAtPayload) {
    return this.http.post(
      `${environment.api_base_url}/notification_campaigns/${id}/reschedule_notification_campaign`,
      payload
    );
  }
}
